import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { PageHeader, Loader, EmptyState } from "@/components/kit";
import { StatusBadge } from "@/components/StatusBadge";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";
import { History, Search } from "lucide-react";

const fmt = (s) => s ? new Date(s).toLocaleString([], { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

export default function VisitorHistory() {
  const [list, setList] = useState(null);
  const [q, setQ] = useState("");
  const [date, setDate] = useState("");

  const load = () => {
    const params = {};
    if (q) params.q = q;
    if (date) params.date = date;
    api.get("/visitors/history", { params }).then((r) => setList(r.data)).catch((e) => toast.error(apiError(e)));
  };
  useEffect(() => { load(); }, []);

  if (!list) return <Loader />;

  return (
    <div>
      <PageHeader title="Visitor History" subtitle="Complete visit records with full timeline." />
      <div className="flex flex-wrap gap-3 mb-5">
        <div className="relative flex-1 min-w-[220px]">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input placeholder="Search name, phone, company, host..." data-testid="history-search" className="pl-9 h-10" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} />
        </div>
        <Input type="date" data-testid="history-date" className="h-10 w-44" value={date} onChange={(e) => setDate(e.target.value)} />
        <Button onClick={load} data-testid="history-filter-btn" className="bg-navy-900 h-10">Filter</Button>
      </div>

      {list.length === 0 ? <EmptyState icon={History} title="No visit records" /> : (
        <div className="bg-white rounded-2xl border border-slate-200 overflow-x-auto sf-fade-up">
          <Table>
            <TableHeader><TableRow className="bg-slate-50">
              <TableHead>Visitor</TableHead><TableHead>Company</TableHead><TableHead>Host</TableHead>
              <TableHead>Requested</TableHead><TableHead>Verified</TableHead><TableHead>Check In</TableHead>
              <TableHead>Check Out</TableHead><TableHead>Duration</TableHead><TableHead>Status</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {list.map((v) => (
                <TableRow key={v.id} data-testid={`history-row-${v.id}`}>
                  <TableCell className="font-medium text-navy-900">{v.visitor_name}<br /><span className="text-xs text-slate-400 font-mono">{v.visitor_phone}</span></TableCell>
                  <TableCell className="text-slate-500">{v.visitor_company}</TableCell>
                  <TableCell className="text-slate-500">{v.person_to_meet}<br /><span className="text-xs text-slate-400">{v.cabin_number}</span></TableCell>
                  <TableCell className="text-xs text-slate-500">{fmt(v.timestamps?.requested_at)}</TableCell>
                  <TableCell className="text-xs text-slate-500">{fmt(v.timestamps?.verified_at)}</TableCell>
                  <TableCell className="text-xs text-slate-500">{fmt(v.checkin_time)}</TableCell>
                  <TableCell className="text-xs text-slate-500">{fmt(v.checkout_time)}</TableCell>
                  <TableCell>{v.duration_minutes != null ? `${v.duration_minutes}m` : "—"}</TableCell>
                  <TableCell><StatusBadge status={v.status} /></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
